import React, { useState } from "react";
import { TextField, Button, Box, Typography, Container } from "@mui/material";
import Swal from "sweetalert2";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { useUser } from "../context/UserContext";

const Login = () => {
    axios.defaults.withCredentials = true;

    const { login } = useUser();
    const navigate = useNavigate();
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");

    const cargando = (mensage) => {
        Swal.fire({
            title: mensage + '...',
            didOpen: () => {
                Swal.showLoading();
            },
            allowOutsideClick: false,
            showConfirmButton: false,
        });
    }

    const alerta = (mensage, icon) => {
        Swal.close();
        Swal.fire({
            title: mensage,
            icon: icon,
            text: "",
            showConfirmButton: false,
            timer: 1500
        });
    }

    const handleSubmit = async (e) => {
        cargando("Cargando")
        e.preventDefault();
        try {
            const response = await axios.post(
                "https://apimedidas.ahouseinterior.com/login.php",
                { email, password },
                { withCredentials: true } // Permitir envío de cookies
            );

            if (response.data.status === "success") {
                login(response.data.user); // Guardar usuario en contexto
                navigate("/dashboard"); // Redirigir al Dashboard
            } else {
                alerta(response.data.message, "error")
            }
        } catch (err) {
            alerta("Error de Conexion", "error")
        }
    };

    return (
        <Container>
            <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center" height="100vh">
                <Typography variant="h4">Iniciar Sesión</Typography>
                <form onSubmit={handleSubmit}>
                    <TextField
                        label="Correo Electrónico"
                        type="email"
                        fullWidth
                        margin="normal"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                    />
                    <TextField
                        label="Contraseña"
                        type="password"
                        fullWidth
                        margin="normal"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                    />
                    <Button type="submit" variant="contained" fullWidth>
                        Iniciar Sesión
                    </Button>
                </form>
            </Box>
        </Container>
    );
};

export default Login;
